export default __webpack_public_path__ + "static/media/icon_facebook.92a8af2e.svg";